// src/shared/components/Tooltip/MouseTooltip.tsx
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './Tooltip.scss';

interface MouseTooltipProps {
  children: ReactNode;
  x:number;
  y:number;
  offsetX?: number;
  offsetY?: number;
}

const MouseTooltip: React.FC<MouseTooltipProps> = ({
  children,
  x:mouseX,
  y:mouseY,
  offsetX = 12,
  offsetY = 12,
}) => {
  const ref = useRef<HTMLDivElement|null>(null);
  const [stylePos,setStylePos] = useState({x:-999,y:-999});

  useEffect(()=>{
    const el = ref.current;
    if (!el) return;

    const rect = el.getBoundingClientRect();

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const w = rect.width;
    const h = rect.height;

    let x = mouseX + offsetX;
    let y = mouseY + offsetY;

    if (x + w > vw) {
      x = mouseX - w - offsetX;
    }

    if (y + h > vh) {
      y = mouseY - h - offsetY;
    }

    x = Math.max(4, Math.min(x, vw - w - 4));
    y = Math.max(4, Math.min(y, vh - h - 4));

    setStylePos({ x, y });
  },[mouseX,mouseY,offsetX,offsetY])

  const node = (
    <div
      ref={ref}
      className="mouse-tooltip-box"
      style={{
        left: stylePos.x,
        top: stylePos.y,
      }}
    >
      {children}
    </div>
  );

  return createPortal(node, document.body);
};

export default MouseTooltip;
